import { useState, useEffect } from 'react';
import Header from './include/header';
import Footer from './include/footer';
import CodPanel from './include/CodLeftPanel';
import { useNavigate } from 'react-router-dom';
import Global from '../APIConfig';
import  axios from "axios";
import AuthUser from "../AuthUser";
import { ToastContainer, toast } from 'react-toastify';
import ListLoader from '../admin/Loaders/ListLoader';
import CopyToClipboard from 'react-copy-to-clipboard';

function CodDashBoard() {
    let navigate = useNavigate();
    const{headers1,logout}=AuthUser();
    const [totalCODCollect, setTotalCODCollect] = useState('0');
    const [totalCodPending, setTotalCodPending] = useState('0');
    const [totalCod, setTotalCod] = useState('0');
    const [list, setList] = useState([]);
    const [drivertList, seDrivertList] = useState([]);
    const [Loading, setLoading] = useState(false);
    const [Subloading, setSubloading] = useState(false);
    const items = JSON.parse(localStorage.getItem('user'));

    useEffect(() => {
        Get30DaysCODCollect();
        Get30DaysCODPending();
        Get30DaysCod();
        FetchDashboardHubCodHistory();
        FetchDashboardDriverCodHistory();
      }, []);
      
    const Get30DaysCODCollect=()=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Get30DaysCODCollect',
            headers:headers1,
            data: {
                 usertype:items.usertype,
                 hubid:items.id
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data;
                setTotalCODCollect(data.label);
                
            }
            else
            {
                setTotalCODCollect(0);
                
            }
          })
          .catch(function (error) {
            if(error.response.status==401){
                logout();
                navigate('/');
                window.location.reload();
            }
            // console.log(error);
          });
    }
    const Get30DaysCODPending=()=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Get30DaysCODPending',
            headers:headers1,
            data: {
                 usertype:items.usertype,
                hubid:items.id
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data;
                setTotalCodPending(data.label);
                
            }
            else
            {
                setTotalCodPending(0);
                
            }
          })
          .catch(function (error) {
            if(error.response.status==401){
                logout();
                navigate('/');
                window.location.reload();
            }
            // console.log(error);
          });
    }
    const Get30DaysCod=()=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Get30DaysCod',
            headers:headers1,
            data: {
                usertype:items.usertype,
                hubid:items.id
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data;
                setTotalCod(data.label);
                
            }
            else
            {
                setTotalCod(0);
                
            }
          })
          .catch(function (error) {
            if(error.response.status==401){
                logout();
                navigate('/');
                window.location.reload();
            }
            // console.log(error);
          });
    }


     const FetchDashboardHubCodHistory=()=>{
            setSubloading(true);
            axios({
                method: 'post',
                url: Global.baseUrl+'FetchDashboardHubCodHistory',
                headers:headers1,
                data: {
                }
              })
              .then(function (response) {
                if(response.data.status == 200)
                {
                    var data=response.data.value;
                    setList(data);
                }
                else
                {
                    setList();
                }
                setSubloading(false);
                setLoading(false);
              })
              .catch(function (error) {
                if(error.response.status==401){
                    toast.error(error.response.statusText);
                    // logout();
                    // navigate('/');
                    // window.location.reload();
                }
                setSubloading(false);
                setLoading(false);
                // console.log(error);
              });
        }

      const FetchDashboardDriverCodHistory=()=>{
            setSubloading(true);
            axios({
                method: 'post',
                url: Global.baseUrl+'FetchDashboardDriverCodHistory',
                headers:headers1,
                data: {
                    usertype:items.usertype,
                    hubid:items.id
                }
              })
              .then(function (response) {
                if(response.data.status == 200)
                {
                    var data=response.data.value;
                    seDrivertList(data);
                }
                else
                {
                    seDrivertList();
                }
                setSubloading(false);
                setLoading(false);
              })
              .catch(function (error) {
                if(error.response.status==401){
                    toast.error(error.response.statusText);
                    // logout();
                    // navigate('/');
                    // window.location.reload();
                }
                setSubloading(false);
                setLoading(false);
                // console.log(error);
              });
        }
    

  return (
    <>
        <CodPanel/>
        <main className='home-section'>
        <Header/>
        <ToastContainer/>
        <div className="overlay"></div>
        <div className='col-12 mt-4'><h2>COD Dashboard</h2></div>
        <div className="row dash_state_box">
                <div className="col-12 col-md-6 col-sm-6 col-xl-4 mb-4">
                    <div className="card border-0 shadow">
                        <div className="card-body">
                            <div className="row d-block d-xl-flex align-items-center">
                                <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                                    <div className="icon-shape icon-shape-default rounded me-4 me-sm-0">
                                        <i className="bx bx-collection"></i>
                                    </div>
                                    <div className="d-sm-none">
                                        <h2 className="fw-extrabold h5"> Revenue</h2>
                                        <h3 className="mb-1">{Number(totalCod).toFixed(2)}</h3>
                                    </div>
                                </div>
                                <div className="col-12 col-xl-7 px-xl-0">
                                    <div className="d-none d-sm-block">
                                        <h2 className=""> Revenue</h2>
                                        <h3 className="">{Number(totalCod).toFixed(2)}</h3>
                                    </div>
                                    <small className="">
                                        Last 30 days
                                    </small> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-6 col-sm-6 col-xl-4 mb-4">
                    <div className="card border-0 shadow">
                        <div className="card-body">
                            <div className="row d-block d-xl-flex align-items-center">
                                <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                                    <div className="icon-shape icon-shape-default rounded me-4 me-sm-0">
                                        <i className="bx bx-cuboid"></i>
                                    </div>
                                    <div className="d-sm-none">
                                        <h2 className="fw-extrabold h5">{items.usertype=='M' ? 'Driver' : 'Hub'} Pending COD</h2>
                                        <h3 className="mb-1">{Number(totalCodPending).toFixed(2)}</h3>
                                    </div>
                                </div>
                                <div className="col-12 col-xl-7 px-xl-0">
                                    <div className="d-none d-sm-block">
                                        <h2 className="">{items.usertype=='M' ? 'Driver' : 'Hub'} Pending COD</h2>
                                        <h3 className="">{Number(totalCodPending).toFixed(2)}</h3>
                                    </div>
                                    <small className="">
                                        Last 30 days
                                    </small> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-6 col-sm-6 col-xl-4 mb-4">
                    <div className="card border-0 shadow">
                        <div className="card-body">
                            <div className="row d-block d-xl-flex align-items-center">
                                <div className="col-12 col-xl-5 text-xl-center mb-3 mb-xl-0 d-flex align-items-center justify-content-xl-center">
                                    <div className="icon-shape icon-shape-default rounded me-4 me-sm-0">
                                        <i className="bx bx-package"></i>
                                    </div>
                                    <div className="d-sm-none">
                                        <h2 className="fw-extrabold h5">{items.usertype=='M' ? 'Driver' : 'Hub'} Collected COD</h2>
                                        <h3 className="mb-1">{Number(totalCODCollect).toFixed(2)}</h3>
                                    </div>
                                </div>
                                <div className="col-12 col-xl-7 px-xl-0">
                                    <div className="d-none d-sm-block">
                                        <h2 className="">{items.usertype=='M' ? 'Driver' : 'Hub'} Collected COD</h2>
                                        <h3 className="">{Number(totalCODCollect).toFixed(2)}</h3>
                                    </div>
                                    <small className="">
                                        Last 30 days
                                    </small> 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
                <div className='row'>
                    {items.usertype =='AD' &&
                    <div className='col-12 col-md-12'>
                        <h2>Hub List</h2>
                       <div className="card card-body border-0 shadow table-wrapper table-responsive">
                            <table className="table table-hover">
                                <thead>
                                
                                    <tr>
                                        <th className="border-gray-200">Hub Code</th>
                                        <th className="border-gray-200">Hub Name </th>
                                        <th className="border-gray-200">Total COD Pay</th>
                                        <th className="border-gray-200">Date / Time</th>
                                    </tr>
                                </thead>
                                {Subloading==true && <ListLoader/>}
                                {list!=undefined && Subloading==false ?
                                <tbody>
                                    {list.map((hub,index)=>{
                                        return(
                                        <tr key={index}>
                                            <td>
                                                <div>
                                                    {hub.uniqueid}
                                                    <CopyToClipboard text={hub.uniqueid} onCopy={()=>{toast.success(hub.uniqueid+' Copied To Clipboard')}}>
                                                        <i className="bx bx-copy"></i>
                                                    </CopyToClipboard>
                                                </div>
                                            </td>
                                            <td><span className="fw-normal text-capitalize">{hub.hubname}</span></td>
                                            <td><span className="fw-normal text-capitalize text-success">{parseFloat(hub.paid).toFixed(2)}</span></td>
                                            <td><span className="fw-normal text-capitalize">{hub.date} {hub.time}</span></td>
                                            
                                        </tr>
                                    )})}                 
                                </tbody>
                                :
                                <tbody><tr><td colSpan={8}>Record Not Found</td></tr></tbody>
                                }
                            </table>
                        </div>
                    </div>
                    }
                    <div className='col-12 col-md-12 py-4'>
                        <h2>Driver List</h2>
                       <div className="card card-body border-0 shadow table-wrapper table-responsive">
                            <table className="table table-hover">
                                <thead>
                                
                                    <tr>
                                        <th className="border-gray-200">Driver Code</th>
                                        <th className="border-gray-200">Driver Name </th>
                                        <th className="border-gray-200">Total COD Pay</th>
                                        <th className="border-gray-200">Date / Time</th>
                                    </tr>
                                </thead>
                                {Subloading==true && <ListLoader/>}
                                {drivertList!=undefined && Subloading==false ?
                                <tbody>
                                    {drivertList.map((dri,index)=>{
                                        return(
                                        <tr key={index}>
                                            <td>
                                                <div>
                                                    {dri.messenger_code}
                                                    <CopyToClipboard text={dri.messenger_code} onCopy={()=>{toast.success(dri.messenger_code+' Copied To Clipboard')}}>
                                                        <i className="bx bx-copy"></i>
                                                    </CopyToClipboard>
                                                </div>
                                            </td>
                                            <td><span className="fw-normal text-capitalize">{dri.messenger_name}</span></td>
                                            <td><span className="fw-normal text-capitalize text-success">{parseFloat(dri.paid).toFixed(2)}</span></td>
                                            <td><span className="fw-normal text-capitalize">{dri.date} {dri.time}</span></td>
                                            
                                        </tr>
                                    )})}                 
                                </tbody>
                                :
                                <tbody><tr><td colSpan={8}>Record Not Found</td></tr></tbody>
                                }
                            </table>
                        </div>
                    </div>
                </div>
            
        <Footer/>
        </main>
    </>
  );
}

export default CodDashBoard;